export default {
  data() {
    return {
      feedbackDragOver: false,
      feedbackDragCounter: 0,
      feedbackUploadLimit: 3,
    };
  },
  methods: {
    onFeedbackDragEnter(e) {
      e.preventDefault();
      this.feedbackDragCounter += 1;
      this.feedbackDragOver = true;
    },
    onFeedbackDragLeave(e) {
      e.preventDefault();
      this.feedbackDragCounter -= 1;
      if (this.feedbackDragCounter <= 0) {
        this.feedbackDragCounter = 0;
        this.feedbackDragOver = false;
      }
    },
    onFeedbackDragOver(e) {
      e.preventDefault();
    },
    onFeedbackDrop(e) {
      this.feedbackDragOver = false;
      this.feedbackDragCounter = 0;
      const files = Array.from(e.dataTransfer.files || []);
      if (!files.length) return;

      const imageFiles = files.filter((file) => this.isFeedbackImageFile(file));
      if (!imageFiles.length) {
        this.$message.warning("请拖拽 jpg、png、gif 格式的图片");
        return;
      }

      const upload = this.$refs.feedbackUpload;
      if (!upload || typeof upload.handleStart !== "function") {
        this.$message.error("上传组件未就绪，请稍后重试");
        return;
      }

      const remaining = this.feedbackUploadLimit - this.imgList.length;
      if (remaining <= 0) {
        this.exceed();
        return;
      }

      const filesToAdd = imageFiles.slice(0, remaining);
      if (imageFiles.length > remaining) {
        this.exceed();
      }

      filesToAdd.forEach((file) => {
        upload.handleStart(file);
      });
    },
    isFeedbackImageFile(file) {
      const acceptTypes = ["image/jpeg", "image/png", "image/gif"];
      if (file.type && acceptTypes.includes(file.type)) {
        return true;
      }
      const ext = (file.name || "").split(".").pop().toLowerCase();
      return ["jpg", "jpeg", "png", "gif"].includes(ext);
    },
  },
};
